<template>
  <section class="contact-banner">
    <div class="overlay">
      <div class="content">
        <h1 ref="headline" class="headline"></h1>
        <p class="subtext">
          ¿Tienes problemas con tu dispositivo Android o iPhone?
          <br />
          No te preocupes, Jean está aquí para ayudarte con confianza y precisión.
        </p>
        <div class="scroll-hint">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="#00f2ff">
            <path d="M12 16l-6-6h12l-6 6z"/>
          </svg>
          <span>Desliza hacia abajo y contáctanos</span>
        </div>

        <!-- ✅ Botón de WhatsApp -->
        <a 
          href="https://wa.me/584125696219" 
          target="_blank" 
          rel="noopener noreferrer" 
          class="whatsapp-btn"
        >
          💬 Escríbenos por WhatsApp
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactBanner',
  mounted() {
    this.$nextTick(() => {
      this.typeWriterEffect("¿Necesitas ayuda informática?", this.$refs.headline, 100)
    })
  },
  methods: {
    typeWriterEffect(text, element, speed) {
      let i = 0
      element.textContent = ''
      const typing = () => {
        if (i < text.length) {
          element.textContent += text.charAt(i)
          i++
          setTimeout(typing, speed)
        }
      }
      typing()
    }
  }
}
</script>

<style scoped>
.contact-banner {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-image: url('@/assets/fondoontactanos.jpg'); /* Reemplaza con tu imagen */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-wrap: wrap;
}

.overlay {
  background: linear-gradient(135deg, rgba(0,0,0,0.6), rgba(0,0,0,0.8));
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(1rem, 5vw, 3rem);
}

.content {
  text-align: center;
  color: white;
  max-width: 700px;
  animation: fadeInUp 1.5s ease-out;
  padding: 1rem;
}

.headline {
  font-size: clamp(2rem, 6vw, 3rem);
  font-weight: bold;
  margin-bottom: 1rem;
  border-right: 3px solid #00f2ff;
  animation: blinkCaret 0.7s step-end infinite;
  text-shadow: 0 2px 4px rgba(0,0,0,0.6);
  white-space: normal;
  overflow: visible;
}

.subtext {
  font-size: clamp(1rem, 4vw, 1.4rem);
  margin-bottom: 2rem;
  opacity: 0.95;
  text-shadow: 0 1px 3px rgba(0,0,0,0.5);
}

.scroll-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #00f2ff;
  font-size: clamp(0.9rem, 3vw, 1.2rem);
  animation: pulse 2s infinite;
  margin-bottom: 1rem;
}

.scroll-hint svg {
  margin-bottom: 0.5rem;
  animation: bounce 2s infinite;
}

/* ✅ Botón WhatsApp */
.whatsapp-btn {
  display: inline-block;
  background: #25D366;
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.whatsapp-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 10px rgba(0,0,0,0.4);
  background: #20b358;
}

@keyframes blinkCaret {
  from, to { border-color: transparent }
  50% { border-color: #00f2ff }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes bounce {
  0%, 100% { transform: translateY(0) }
  50% { transform: translateY(10px) }
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
